"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMerchantLocationtype = exports.IMerchantAdvancedbilling = exports.IMerchantEnvironment = exports.IMerchantFrozen = exports.IMerchantInactive = exports.IMerchantStatus = exports.IMerchantNew = void 0;
var IMerchantNew;
(function (IMerchantNew) {
    IMerchantNew[IMerchantNew["NOT_NEW_0"] = 0] = "NOT_NEW_0";
    IMerchantNew[IMerchantNew["NEW_1"] = 1] = "NEW_1";
})(IMerchantNew = exports.IMerchantNew || (exports.IMerchantNew = {}));
var IMerchantStatus;
(function (IMerchantStatus) {
    IMerchantStatus[IMerchantStatus["NOT_READY_0"] = 0] = "NOT_READY_0";
    IMerchantStatus[IMerchantStatus["READY_1"] = 1] = "READY_1";
    IMerchantStatus[IMerchantStatus["BOARDED_2"] = 2] = "BOARDED_2";
    IMerchantStatus[IMerchantStatus["MANUAL_3"] = 3] = "MANUAL_3";
    IMerchantStatus[IMerchantStatus["CLOSED_4"] = 4] = "CLOSED_4";
    IMerchantStatus[IMerchantStatus["INCOMPLETE_5"] = 5] = "INCOMPLETE_5";
    IMerchantStatus[IMerchantStatus["PENDING_6"] = 6] = "PENDING_6";
})(IMerchantStatus = exports.IMerchantStatus || (exports.IMerchantStatus = {}));
var IMerchantInactive;
(function (IMerchantInactive) {
    IMerchantInactive[IMerchantInactive["ACTIVE_0"] = 0] = "ACTIVE_0";
    IMerchantInactive[IMerchantInactive["INACTIVE_1"] = 1] = "INACTIVE_1";
})(IMerchantInactive = exports.IMerchantInactive || (exports.IMerchantInactive = {}));
var IMerchantFrozen;
(function (IMerchantFrozen) {
    IMerchantFrozen[IMerchantFrozen["NOT_FROZEN_0"] = 0] = "NOT_FROZEN_0";
    IMerchantFrozen[IMerchantFrozen["FROZEN_1"] = 1] = "FROZEN_1";
})(IMerchantFrozen = exports.IMerchantFrozen || (exports.IMerchantFrozen = {}));
var IMerchantEnvironment;
(function (IMerchantEnvironment) {
    IMerchantEnvironment["SUPERMARKET_SUPERMARKET"] = "supermarket";
    IMerchantEnvironment["MAIL_ORDER__TELEPHONE_ORDER_MOTO"] = "moto";
    IMerchantEnvironment["CARD_PRESENT_CARDPRESENT"] = "cardPresent";
    IMerchantEnvironment["FUEL_FUEL"] = "fuel";
    IMerchantEnvironment["SERVICE_STATION_SERVICESTATION"] = "serviceStation";
    IMerchantEnvironment["RESTAURANT_RESTAURANT"] = "restaurant";
    IMerchantEnvironment["ECOMMERCE_ECOMMERCE"] = "ecommerce";
})(IMerchantEnvironment = exports.IMerchantEnvironment || (exports.IMerchantEnvironment = {}));
var IMerchantAdvancedbilling;
(function (IMerchantAdvancedbilling) {
    IMerchantAdvancedbilling[IMerchantAdvancedbilling["ADVANCEDBILLING_IS_DISABLED_0"] = 0] = "ADVANCEDBILLING_IS_DISABLED_0";
    IMerchantAdvancedbilling[IMerchantAdvancedbilling["ADVANCEDBILLING_IS_ENABLED_1"] = 1] = "ADVANCEDBILLING_IS_ENABLED_1";
})(IMerchantAdvancedbilling = exports.IMerchantAdvancedbilling || (exports.IMerchantAdvancedbilling = {}));
var IMerchantLocationtype;
(function (IMerchantLocationtype) {
    IMerchantLocationtype[IMerchantLocationtype["RETAIL_STOREFRONT_77"] = 77] = "RETAIL_STOREFRONT_77";
    IMerchantLocationtype[IMerchantLocationtype["WAREHOUSE_78"] = 78] = "WAREHOUSE_78";
    IMerchantLocationtype[IMerchantLocationtype["PRIVATE_RESIDENCE_79"] = 79] = "PRIVATE_RESIDENCE_79";
    IMerchantLocationtype[IMerchantLocationtype["OTHERS_80"] = 80] = "OTHERS_80";
    IMerchantLocationtype[IMerchantLocationtype["P_81"] = 81] = "P_81";
})(IMerchantLocationtype = exports.IMerchantLocationtype || (exports.IMerchantLocationtype = {}));
